<template>
  <div>
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder='Pesquisar por código, nome ou nome amigável'
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
    </div>

    <hr>

    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>ID</th>
              <th>Código</th>
              <th>Nome</th>
              <th>Nome Amigável</th>
              <th>Descrição</th>
              <th>Descrição Amigável</th>
              <th>Status Final</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="status in driverIndicationStatuses" :key="status.id">
              <td>{{ status.id }}</td>
              <td>{{ status.code }}</td>
              <td>{{ status.name }}</td>
              <td>{{ status.friendlyName }}</td>
              <td>{{ status.description }}</td>
              <td>{{ status.friendlyDescription }}</td>
              <td>
                <span v-if="status.closed" class="badge badge-success">Sim</span>
                <span v-else class="badge badge-secondary">Não</span>
              </td>
              <td>{{ status.createdAt | datetime }}</td>
              <td>{{ status.updatedAt | datetime }}</td>
              <td>
                <button class="btn btn-outline" @click="editStatus(status)">
                  Editar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <Modal v-model="showEditModal" width="md">
      <div slot="header">
        <h3>Editar Status</h3>
      </div>
      <div v-if="currentStatus" class="status-form">
        <div class="form-group">
          <label>Código</label>
          <input disabled v-model="currentStatus.code" class="form-control" />
        </div>
        <div class="form-group">
          <label>Nome</label>
          <input v-model="currentStatus.name" class="form-control" />
        </div>
        <div class="form-group">
          <label>Nome Amigável</label>
          <input v-model="currentStatus.friendlyName" class="form-control" />
        </div>
        <div class="form-group">
          <label>Descrição</label>
          <textarea v-model="currentStatus.description" class="form-control" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label>Descrição Amigável</label>
          <textarea v-model="currentStatus.friendlyDescription" class="form-control" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label class="checkbox-inline">
            <input type="checkbox" v-model="currentStatus.closed" />
            Status Final (indica que o processo foi encerrado)
          </label>
        </div>
      </div>
      <template slot="footer">
        <button @click="showEditModal = false" class="btn btn-outline mr-2">Cancelar</button>
        <button @click="saveStatus" class="btn btn-primary">Salvar</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/shares/specialTag/Modal'
import Pagination from '@/components/shares/specialTag/Pagination'
import ModelMapper from '@/mixins/ModelMapper'
import EntityProxy from '@/models/EntityProxy'
import { SearchIcon } from 'vue-feather-icons'

export default {
  name: 'DriverIndicationStatusIndex',
  components: { Modal, Pagination, SearchIcon },
  mixins: [ModelMapper],
  computed: {
    driverIndicationStatuses() {
      return this.getModels || []
    }
  },
  created() {
    this.order = ['updated_at', 'desc']
    this.asyncTemplateSelect({ byURL: true, pagination: true })
  },
  data: () => ({
    nameModel: 'DriverIndicationStatus',
    modelPathPrefix: 'admin/maestro',
    orderBy: 'updated_at',
    showEditModal: false,
    currentStatus: null
  }),
  methods: {
    find() {
      this.asyncTemplateSelect()
    },
    editStatus(status) {
      this.currentStatus = EntityProxy.clone(status)
      this.showEditModal = true
    },
    saveStatus() {
      const { id, ...data } = this.currentStatus
      this.axios.put(`admin/maestro/driver_indication_statuses/${id}`, data)
        .then(() => {
          this.$notify.add('Status atualizado com sucesso!')
          this.showEditModal = false
          this.find()
        })
        .catch(e => this.$notify.addError(e))
    }
  },
  watch: {
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  }
}
</script>

<style scoped>
.status-form label {
  color: var(--primary-text-color);
}

.status-form .form-control {
  background-color: var(--card-bg);
  border-color: var(--border-color);
  color: var(--primary-text-color);
}

.status-form .form-control:focus {
  border-color: var(--primary-color);
}
</style>
